// frontend-react/src/components/sales/SalesSummary.jsx
import React, { memo } from 'react';
import Remise, { calcTotalsWithRemise } from '../Remise.jsx';

function fmtXof(n) {
  return Number(n || 0).toLocaleString('fr-FR');
}

function clampNumber(n, min, max, fallback) {
  const x = Number(n);
  if (!Number.isFinite(x)) return fallback;
  return Math.max(min, Math.min(max, x));
}

export default memo(function SalesSummary({
  totalHT,
  tvaPct,
  setTvaPct,
  discount,
  setDiscount,
}) {
  const safeTva = clampNumber(tvaPct, 0, 100, 0);

  return (
    <div className="space-y-4">
      {/* TVA réglable */}
      <div className="bg-white border border-slate-200 rounded-xl p-3 shadow-sm">
        <div className="flex items-center justify-between mb-3 gap-3">
          <div className="text-sm font-medium">TVA (%)</div>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={0}
              max={100}
              step="0.01"
              value={safeTva}
              onChange={e => setTvaPct(clampNumber(e.target.value, 0, 100, 18))}
              className="border border-slate-200 rounded-lg px-2 py-1 w-28 text-right bg-white focus:ring-2 focus:ring-slate-300 focus:border-slate-400"
            />
            <button
              type="button"
              onClick={() => setTvaPct(18)}
              className="px-2 py-1 border border-slate-200 rounded-lg text-xs hover:bg-slate-50"
              title="Remettre 18%"
            >
              18%
            </button>
            <button
              type="button"
              onClick={() => setTvaPct(0)}
              className="px-2 py-1 border border-slate-200 rounded-lg text-xs hover:bg-slate-50"
              title="TVA 0%"
            >
              0%
            </button>
          </div>
        </div>

        <div className="flex justify-between text-sm mb-1">
          <span>Total HT (estimé)</span>
          <span className="font-medium">{fmtXof(totalHT)} XOF</span>
        </div>
        <div className="text-xs text-slate-500">
          Le TTC affiché ci-dessous inclut la remise.
        </div>
      </div>

      {/* Remise */}
      <Remise
        totalHT={totalHT}
        tvaPct={safeTva}
        value={discount}
        onChange={setDiscount}
      />
    </div>
  );
});
